import { useTranslation } from '@/i18n';
import { PrimaryButton } from '@/components/ui/buttons/PrimaryButton';
import { IconScout } from '@/components/ui/images/IconScout';
import { Table } from '@/components/ui/tables/Table';
import { FilterDropdown } from '@/components/ui/filters/FilterDropdown';
import { Selector } from '@/components/ui/inputs/selector';
import { useRoles } from '@/hooks/authorization/useRoles';


export function RolesForm() {
  const { t: translate } = useTranslation();

  const {
    data,
    totalRecords,
    isLoading,
    page,
    pageSize,
    setPage,
    setPageSize,
    onSearch,
    onSortChange,
    columns,
    actions,
    openNewRequestPanel,
    statusOptions,
    typeOptions,
    statusValue,
    typeValue,
    handleStatusChange,
    handleTypeChange,
  } = useRoles();

  return (
    <div className="flex flex-col gap-6" data-testid="roles-form">
      <div>
        <PrimaryButton
          onClick={() => openNewRequestPanel()}
          iconLeft={<IconScout name="plus" />}
        >
          {translate('authorization:roles.newRole')}
        </PrimaryButton>
      </div>

      <div className="flex flex-wrap gap-3 items-center">
        <FilterDropdown
          values={{ status: statusValue, type: typeValue }}
          extraFilters={(
            <div className="flex flex-col gap-4 min-w-[250px]">
              <Selector
                label={translate('authorization:roles.filters.status')}
                options={statusOptions}
                value={statusValue}
                onChange={handleStatusChange}
              />
              <Selector
                label={translate('authorization:roles.filters.type')}
                options={typeOptions}
                value={typeValue}
                onChange={handleTypeChange}
              />
            </div>
          )}
        />
      </div>

      <Table
        columns={columns}
        data={data}
        totalRows={totalRecords}
        isLoading={isLoading}
        emptyMessage={translate('authorization:roles.messages.noResults')}
        searchable
        onSearch={onSearch}
        serverSideSort
        onSortChange={onSortChange}
        initialSort={{ key: 'name', direction: 'asc' }}
        pagination={{
          page,
          pageSize,
          total: totalRecords,
          onChange: setPage,
          onPageSizeChange: setPageSize,
        }}
        data-testid="table-roles"
        actions={actions}
      />
    </div>
  );
}

export default RolesForm;
